import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumbs, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  // Lets the current name truncate instead of widening the page.
  breadcrumbs: {
    minWidth: 0,
    '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' },
    '& .MuiBreadcrumbs-li:last-child': { minWidth: 0 },
  },
  separator: {
    fontSize: 12,
    color: theme.palette.text.shadow,
  },
  button: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    '@media (hover: none) and (pointer: coarse)': { minHeight: theme.spacing(5.5) },
  },
  current: { color: theme.palette.text.primary },
}));

type NavigationProps = {
  t: TFunction;
  name: string;
  handleNavigateBack: () => void;
};

const Navigation: FC<NavigationProps> = ({ t, name, handleNavigateBack }) => {
  const classes = useStyles();

  return (
    <nav aria-label={t('users:contacts')} className={classes.container}>
      <Breadcrumbs
        className={classes.breadcrumbs}
        separator={<FontAwesomeIcon icon="chevron-right" className={classes.separator} />}
      >
        <Button className={classes.button} onClick={handleNavigateBack}>
          {t('users:contacts')}
        </Button>
        <Typography
          noWrap
          variant="subtitle2"
          aria-current="page"
          title={name}
          className={classes.current}
        >
          {name}
        </Typography>
      </Breadcrumbs>
    </nav>
  );
};

export default Navigation;
